import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Конфигурация Firebase — только проект onelife-45bcb (без env, чтобы не подхватить старый кэш/slider-605a3)
const firebaseConfig = {
  apiKey: "AIzaSyAyI9j4BLTPed6x64ZPzc-cJPA_N_ENasQ",
  authDomain: "onelife-45bcb.firebaseapp.com",
  projectId: "onelife-45bcb",
  storageBucket: "onelife-45bcb.firebasestorage.app",
  messagingSenderId: "471143869525",
  appId: "1:471143869525:web:800e49e29c4033ac27b8dc",
  measurementId: "G-0DMZ86PH5M"
};

// Инициализация Firebase
const app = initializeApp(firebaseConfig);

// Analytics (только если поддерживается и не в dev без измерения)
if (typeof window !== 'undefined') {
  isSupported().then((yes) => yes && getAnalytics(app)).catch(() => {});
}

// Инициализация сервисов
export const auth = getAuth(app);

// Firestore с персистентным кэшем и поддержкой нескольких вкладок (новый API вместо enableIndexedDbPersistence)
let firestoreDb;
if (typeof window !== 'undefined') {
  try {
    firestoreDb = initializeFirestore(app, {
      cache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
  } catch (err) {
    console.warn('Firestore persistent cache failed, using default', err);
    firestoreDb = getFirestore(app);
  }
} else {
  firestoreDb = getFirestore(app);
}
export const db = firestoreDb;

export const storage = getStorage(app);

// Провайдеры аутентификации
export const googleProvider = new GoogleAuthProvider();

// Настройка Google провайдера
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
